import React from 'react';

import {ReactComponent as AllGamesIcon} from "../images/icons/allGames.svg";
import {ReactComponent as Favorite} from "../images/icons/favorite.svg";

import img1 from '../images/cards/poker/card-1.jpg'
import img2 from '../images/cards/poker/card-2.jpg'
import img3 from '../images/cards/poker/card-3.jpg'
import img4 from '../images/cards/poker/card-4.jpg'


export const PokerDB = [
  {
    image: img1,
    name: 'Poker Games',

  },
  {
    image: img2,
    name: 'Poker Games',

  },
  {
    image: img3,
    name: 'Poker Games',

  },
  {
    image: img4,
    name: 'Poker Games',

  },
  {
    image: img3,
    name: 'Poker Games',

  },
  {
    image: img3,
    name: 'Poker Games',

  },
  {
    image: img3,
    name: 'Poker Games',

  },
  {
    image: img3,
    name: 'Poker Games',

  }
]
